// ============================================================
// Datei: src/pages/ressorts/chai/ChaiMobile.jsx
//
// ÄNDERUNGEN:
// - ShiftTable nutzt jetzt departmentName + filterFn
// - dadurch bleiben Kuchen & Kaffee / Crépes sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

// Guests
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./chaiMobile.css";

const ChaiMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	setSelectedVolunteer,
	downloadCcEmails
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	// Untertab für den Bereich "Libellen"
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	// ============================================================
	// SHIFTS
	// ============================================================
	const chaiKuchen = shifts.filter(
		(s) => s.shiftId >= 301 && s.shiftId <= 310
	);

	const chaiCrepes = shifts.filter(
		(s) => s.shiftId >= 311 && s.shiftId <= 320
	);

	// ============================================================
	// TABS
	// ============================================================
	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="chai-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Chai"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{/* ================= SHIFTS ================= */}
					{activeTab === "shifts" && (
						<>
							<h2 className="chai-subheading">Kuchen & Kaffee</h2>
							<ShiftTable
								shifts={chaiKuchen}
								departmentName="Chai"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 301 && shift.shiftId <= 310}
							/>

							<h2 className="chai-subheading">Crépes</h2>
							<ShiftTable
								shifts={chaiCrepes}
								departmentName="Chai"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 311 && shift.shiftId <= 320}
							/>



						</>
					)}

					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{/* ================= EXTRAS ================= */}
					{activeTab === "extras" && (
						<div>
						</div>
					)}
				</div>
			</div>

			{/* ================= EDIT GUEST ================= */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ================= DELETE GUEST ================= */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default ChaiMobile;